import { request, requestFormData } from "./request";
import { ContentTypes } from "../constants";
import { RequestHeaders } from "./request-base";
export interface IPostProps<T> {
  url: string;
  state: any; //IRootState;
  body?: T;
  customHeaders?: RequestHeaders;
  processResponse?: <R>(response: Response) => Promise<R>;
}

export interface IUploadProps {
  url: string;
  body: FormData;
  state?: any;
}

export const post = <TResult, TBody>(props: IPostProps<TBody>) =>
  request<TResult, TBody>({
    ...props,
    contentType: ContentTypes.JSON,
    method: "POST",
  });

export const upload = <TResult>(props: IUploadProps) =>
  requestFormData<TResult>({
    ...props,
  });
